import { postCreatePaymentSystem } from '../api/postCreatePaymentSystem';
import { setGetListPaymentSystem } from './setGetListPaymentSystem';
const setPostCreatePaymentSystem = (params ) => {
    return async (dispatch, getState) => {
        try {
            await postCreatePaymentSystem(params);
            dispatch(setGetListPaymentSystem({
                search: ''
            }))
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreatePaymentSystem
}